export function setCookie(cname, cvalue, exhours) {
    let params = {};
    try {
        const d = new Date();
        d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + encodeURIComponent(cvalue) + ";" + expires + ";path=/";
    } catch(e) {
        console.error(e);
    }
    return params;
}